import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { AngularFireFunctions } from "@angular/fire/compat/functions";
import { BehaviorSubject } from "rxjs";
import { UserService } from "../user.service";

@Injectable({
  providedIn: 'root',
})
export class ProfileService {

  private user = new BehaviorSubject(null);
  currentUser = this.user.asObservable();

  constructor(
    private userService: UserService,
    private angularFunctions: AngularFireFunctions,
    private angularFirestore: AngularFirestore,
  ) {
    const user = userService.currentUserValue;
    this.user.next(user);
    // this.getCurrentUser();
  }

  public getCurrentUser(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      resolve(this.userService.currentUserValue);
    }).then((user) => {
      this.user.next(user);
    });
  }

  async setAdminClaim() {
    try {
      const callable = this.angularFunctions.httpsCallable('createAdmin');

      callable({})
        .toPromise()
        .then((result) => console.log('setAdminClaim', result))
        .catch((error) => console.log('setAdminClaim', error));

    } catch (error) {
      console.log('setAdminClaim(): ' + JSON.stringify(error));
    }
  }

  async test(email: string) {
    try {
      // const callable = this.angularFunctions.httpsCallable('testAutoCloseUnjoined');
      // const callable = this.angularFunctions.httpsCallable('createAdmin');

      // callable({
      // })
      //   .toPromise()
      //   .then((result) => console.log('test', result))
      //   .catch((error) => console.log('test', error));
      const callable = this.angularFunctions.httpsCallable('sendDocusign');

      callable({
        email: email,
        doctor_id: 'doctor_id_admin_1',
        patient_id: 'patient_id_admin_1'
      })
        .toPromise()
        .then((result) => console.log('test', result))
        .catch((error) => console.log('test', error));
    } catch (error) {
      console.log('test(): ' + JSON.stringify(error));
    }
  }

}